import ActiveStateSelect from './ActiveStateSelect'
import AlarmDeviceTypeSelect from './AlarmDeviceTypeSelect'
import AlarmTypeSelect from './AlarmTypeSelect'
import AppReserveResultSelect from './AppReserveResultSelect'
import CameraCtrlerType from './CameraCtrlerType'
import CameraTypeSelect from './CameraTypeSelect'
import ChargeStatusSelect from './ChargeStatusSelect'
import ChargingConnectorTypesSelect from './ChargingConnectorTypesSelect'
import ChargingFeeDayTypeSelect from './ChargingFeeDayTypeSelect'
import ChargingFeeDiscountTargetSelect from './ChargingFeeDiscountTargetSelect'
import ChargingFeeDiscountTypeSelect from './ChargingFeeDiscountTypeSelect'
import ChargingFeePeakTypeSelect from './ChargingFeePeakTypeSelect'
import ChargingPointSelect from './ChargingPointSelect'
import ChargingPointStatusSelect from './ChargingPointStatusSelect'
import ChargingPointTypesSelect from './ChargingPointTypesSelect'
import CityAreaSelect from './CityAreaSelect'
import CitySelect from './CitySelect'
import CloseReasonSelect from './CloseReasonSelect'
import CompaniesSelect from './CompaniesSelect'
import ControllerTypeSelect from './ControllerTypeSelect'
import DeviceCtrlerTypeSelect from './DeviceCtrlerTypeSelect'
import DeviceDisplayNemeSelect from './DeviceDisplayNemeSelect'
import DeviceSelect from './DeviceSelect'
import DeviceStatusSelect from './DeviceStatusSelect'
import EelectricitymeterControllerTypeSelect from './EelectricitymeterControllerTypeSelect'
import EelectricitymeterSelect from './EelectricitymeterSelect'
import GroupSelect from './GroupSelect'
import MultipleDistrict from './MultipleDistrict'
import OTAFilesSelect from './OTAFilesSelect'
import ParkingFeeCitySelect from './ParkingFeeCitySelect'
import ParkingFeeRateTypeSelect from './ParkingFeeRateTypeSelect'
import ParkingLotAutoCompleteSelect from './ParkingLotAutoCompleteSelect'
import ParkingLotDemandResponseTypeSelect from './ParkingLotDemandResponseTypeSelect'
import ParkingSpaceTypeSelect from './ParkingSpaceTypeSelect'
import PersonalNotificationSituationSelect from './PersonalNotificationSituationSelect'
import PowerControllerTypeSelect from './PowerControllerTypeSelect'
import ProblemCarItemSelect from './ProblemCarItemSelect'
import RepairCloseReasonSelect from './RepairCloseReasonSelect'
import RepairedReasonSelect from './RepairedReasonSelect'
import RepairerSelect from './RepairerSelect'
import RepairStateSelect from './RepairStateSelect'
import ReportDeviceSelect from './ReportDeviceSelect'
import ReportRangeTimeSelect from './ReportRangeTimeSelect'
import ReportReasonSelect from './ReportReasonSelect'
import SearchRangeSelect from './SearchRangeSelect'
import SessionChildrenSelect from './SessionChildrenSelect'
import SessionLayerSelect from './SessionLayerSelect'
import SessionSelect from './SessionSelect'
import SessionTreeSelect from './SessionTreeSelect'
import ShelfStatusSelect from './ShelfStatusSelect'
import StandSelect from './StandSelect'
import SubDeviceSelect from './SubDeviceSelect'
import SwitchBoxSelect from './SwitchBoxSelect'
import UserUsageStatusSelect from './UserUsageStatusSelect'
import WaterMeterControllerTypeSelect from './WaterMeterControllerTypeSelect'
import WeatherControllerTypeSelect from './WeatherControllerTypeSelect'

interface IOptionsSelect {
  DeviceSelect: typeof DeviceSelect
  DeviceStatusSelect: typeof DeviceStatusSelect
  DeviceDisplayNemeSelect: typeof DeviceDisplayNemeSelect
  GroupSelect: typeof GroupSelect
  SessionSelect: typeof SessionSelect
  MultipleDistrict: typeof MultipleDistrict
  RepairerSelect: typeof RepairerSelect
  RepairStateSelect: typeof RepairStateSelect
  RepairCloseReasonSelect: typeof RepairCloseReasonSelect
  CameraTypeSelect: typeof CameraTypeSelect
  SwitchBoxSelect: typeof SwitchBoxSelect
  ControllerTypeSelect: typeof ControllerTypeSelect
  SubDeviceSelect: typeof SubDeviceSelect
  WeatherControllerTypeSelect: typeof WeatherControllerTypeSelect
  PowerControllerTypeSelect: typeof PowerControllerTypeSelect
  UserUsageStatusSelect: typeof UserUsageStatusSelect
  ReportRangeTimeSelect: typeof ReportRangeTimeSelect
  ReportDeviceSelect: typeof ReportDeviceSelect
  ActiveStateSelect: typeof ActiveStateSelect
  CloseReasonSelect: typeof CloseReasonSelect
  RepairedReasonSelect: typeof RepairedReasonSelect
  ReportReasonSelect: typeof ReportReasonSelect
  SessionTreeSelect: typeof SessionTreeSelect
  CameraCtrlerType: typeof CameraCtrlerType
  EelectricitymeterControllerTypeSelect: typeof EelectricitymeterControllerTypeSelect
  WaterMeterControllerTypeSelect: typeof WaterMeterControllerTypeSelect
  AlarmDeviceTypeSelect: typeof AlarmDeviceTypeSelect
  DeviceCtrlerTypeSelect: typeof DeviceCtrlerTypeSelect
  ChargingPointTypesSelect: typeof ChargingPointTypesSelect
  ShelfStatusSelect: typeof ShelfStatusSelect
  AppReserveResultSelect: typeof AppReserveResultSelect
  PersonalNotificationSituationSelect: typeof PersonalNotificationSituationSelect
  SearchRangeSelect: typeof SearchRangeSelect
  ProblemCarItemSelect: typeof ProblemCarItemSelect
  StandSelect: typeof StandSelect
  EelectricitymeterSelect: typeof EelectricitymeterSelect
  SessionLayerSelect: typeof SessionLayerSelect
  ChargingPointSelect: typeof ChargingPointSelect
  ChargingConnectorTypesSelect: typeof ChargingConnectorTypesSelect
  CitySelect: typeof CitySelect
  ChargingFeeDayTypeSelect: typeof ChargingFeeDayTypeSelect
  ChargingFeeDiscountTargetSelect: typeof ChargingFeeDiscountTargetSelect
  ChargingFeeDiscountTypeSelect: typeof ChargingFeeDiscountTypeSelect
  ParkingFeeCitySelect: typeof ParkingFeeCitySelect
  SessionChildrenSelect: typeof SessionChildrenSelect
  ParkingLotAutoCompleteSelect: typeof ParkingLotAutoCompleteSelect
  ParkingFeeRateTypeSelect: typeof ParkingFeeRateTypeSelect
  CityAreaSelect: typeof CityAreaSelect
  ParkingLotDemandResponseTypeSelect: typeof ParkingLotDemandResponseTypeSelect
  ChargingPointStatusSelect: typeof ChargingPointStatusSelect
  ChargeStatusSelect: typeof ChargeStatusSelect
  ParkingSpaceTypeSelect: typeof ParkingSpaceTypeSelect
  AlarmTypeSelect: typeof AlarmTypeSelect
  OTAFilesSelect: typeof OTAFilesSelect
  CompaniesSelect: typeof CompaniesSelect
  ChargingFeePeakTypeSelect: typeof ChargingFeePeakTypeSelect
}

const OptionsSelect: IOptionsSelect = {
  ChargingFeePeakTypeSelect,
  DeviceSelect,
  DeviceStatusSelect,
  DeviceDisplayNemeSelect,
  GroupSelect,
  SessionSelect,
  MultipleDistrict,
  RepairerSelect,
  RepairStateSelect,
  RepairCloseReasonSelect,
  CameraTypeSelect,
  SwitchBoxSelect,
  ControllerTypeSelect,
  SubDeviceSelect,
  WeatherControllerTypeSelect,
  PowerControllerTypeSelect,
  UserUsageStatusSelect,
  ReportDeviceSelect,
  ReportRangeTimeSelect,
  ActiveStateSelect,
  CloseReasonSelect,
  RepairedReasonSelect,
  ReportReasonSelect,
  SessionTreeSelect,
  CameraCtrlerType,
  EelectricitymeterControllerTypeSelect,
  WaterMeterControllerTypeSelect,
  AlarmDeviceTypeSelect,
  DeviceCtrlerTypeSelect,
  ChargingPointTypesSelect,
  ShelfStatusSelect,
  AppReserveResultSelect,
  PersonalNotificationSituationSelect,
  SearchRangeSelect,
  ProblemCarItemSelect,
  StandSelect,
  EelectricitymeterSelect,
  SessionLayerSelect,
  ChargingPointSelect,
  ChargingConnectorTypesSelect,
  CitySelect,
  ChargingFeeDayTypeSelect,
  ChargingFeeDiscountTargetSelect,
  ChargingFeeDiscountTypeSelect,
  ParkingFeeCitySelect,
  SessionChildrenSelect,
  ParkingLotAutoCompleteSelect,
  ParkingFeeRateTypeSelect,
  CityAreaSelect,
  ParkingLotDemandResponseTypeSelect,
  ChargingPointStatusSelect,
  ChargeStatusSelect,
  ParkingSpaceTypeSelect,
  AlarmTypeSelect,
  OTAFilesSelect,
  CompaniesSelect,
}

export default OptionsSelect
